export const LocationRenderer = ({value}) => {
  const values = (value || '').split(' ')
  if (values.length === 2) {
    return value
  }

  return ''
}
